import { useState } from 'react'

export const useClipboard = () => {
  const [state, setState] = useState('initial')
  const isError = state === 'error'
  const isSuccess = state === 'success'
  const isInitial = state === 'initial'
  function copyToClipboard(text: string) {
    try {
      navigator.clipboard.writeText(text)
      setState('success')
    } catch {
      console.error('Could not write to clipboard.')
      setState('error')
    }
  }
  return { copyToClipboard, state, isInitial, isSuccess, isError }
}
